module.exports = "/_next/static/images/AggregationIdentityResolution@2x-b819d9315c1271b3f7bbbaf3ff1ad031.webp";